// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BigItem_wrapper__1Y8WS","image":"BigItem_image__HErgd","content-container":"BigItem_content-container__3IxCO"};